import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable()
export class DateInterceptor implements HttpInterceptor {
  private dateRegex =
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z?$/;

  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.convertDates(event.body);
        }
        return event;
      })
    );
  }

  private convertDates(object: any) {
    if (!object || !(object instanceof Object)) {
      return;
    }

    // Each value is visited exactly once: an array through its items, an object through its
    // keys. (Visiting arrays both ways converted a nested list several times over.)
    if (object instanceof Array) {
      for (let i = 0; i < object.length; i++) {
        const item = object[i];
        if (typeof item === 'string') {
          if (this.dateRegex.test(item)) {
            object[i] = new Date(item);
          }
        } else {
          this.convertDates(item);
        }
      }
      return;
    }

    for (const key of Object.keys(object)) {
      const value = object[key];
      if (typeof value === 'string') {
        if (this.dateRegex.test(value)) {
          object[key] = new Date(value);
        }
      } else if (value instanceof Object) {
        this.convertDates(value);
      }
    }
  }
}
